import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CDNVhostCreate, CDNVhost, XDNFeatures } from '../../shared/models/cdn-vhost.models';

@Injectable({
  providedIn: 'root',
})
export class CDNVhostService {
  private http = inject(HttpClient);

  public createVhost(data: CDNVhostCreate): Observable<CDNVhost> {
    return this.http.post<CDNVhost>('/vhost-management/vhost', data);
  }

  public getVhosts(): Observable<CDNVhost[]> {
    return this.http.get<CDNVhost[]>('/vhost-management/vhost');
  }

  public getVhost(websiteId: number): Observable<CDNVhost> {
    return this.http.get<CDNVhost>(`/vhost-management/vhost/${websiteId}`);
  }

  public searchVhost(search: string): Observable<CDNVhost[]> {
    return this.http.post<CDNVhost[]>('/vhost-management/vhost/search', { domain: search });
  }

  public getVhostsBatch(offset: number, limit: number, search?: string): Observable<CDNVhost[]> {
    let url = `/vhost-management/vhost/batch?offset=${offset}&limit=${limit}`;
    if (search && search.trim() !== '') {
      url = `${url}&search=${search}`;
    }

    return this.http.get<CDNVhost[]>(url);
  }

  public getVhostsCount(): Observable<number> {
    return this.http.get<number>('/vhost-management/vhost/count');
  }

  public deleteVhost(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/vhost-management/vhost/${websiteId}`);
  }

  public clearCache(websiteId: number): Observable<void> {
    return this.http.post<void>(`/vhost-management/vhost/${websiteId}/clear`, null);
  }

  public enableXDN(websiteId: number): Observable<void> {
    return this.http.post<void>(`/vhost-management/vhost/${websiteId}/xdn`, null);
  }

  public disableXDN(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/vhost-management/vhost/${websiteId}/xdn`);
  }

  public enableCDN(websiteId: number): Observable<void> {
    return this.http.patch<void>(`/vhost-management/vhost/${websiteId}/cdn`, {});
  }

  public disableCDN(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/vhost-management/vhost/${websiteId}/cdn`);
  }

  public syncXDNs(): Observable<void> {
    return this.http.post<void>('/vhost-management/vhost/resync', {});
  }

  public getXDNFeatures(websiteId: number): Observable<XDNFeatures> {
    return this.http.get<XDNFeatures>(`/vhost-management/vhost/${websiteId}/xdn/features`);
  }

  public setXDNFeatures(websiteId: number, data: XDNFeatures): Observable<void> {
    return this.http.post<void>(`/vhost-management/vhost/${websiteId}/xdn/features`, data);
  }

  public deleteXDNFeatures(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/vhost-management/vhost/${websiteId}/xdn/features`);
  }

  public updateServerIps(serverId: string): Observable<void> {
    return this.http.patch<void>(`/vhost-management/vhost/servers/${serverId}`, {});
  }
}
